import { useState, useEffect } from 'react';

export default function GoogleDriveVideo({ fileId, title, className = "" }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = () => {
    setHasError(true);
  };

  return (
    <div className={`relative ${className}`}>
      <div className="w-full rounded-2xl overflow-hidden shadow-xl bg-gray-100">
        {!hasError ? (
          <div className="relative w-full" style={{ height: '56.25vw', maxHeight: '400px', minHeight: '200px' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src={`https://drive.google.com/file/d/${fileId}/preview?usp=embed_facebook`}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onLoad={handleLoad}
              onError={handleError}
            />
          </div>
        ) : (
          <div className="w-full flex items-center justify-center bg-gray-100 rounded-2xl" style={{ height: '56.25vw', maxHeight: '400px', minHeight: '200px' }}>
            <div className="text-center text-gray-600">
              <svg className="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              <p className="text-lg font-semibold">Video Unavailable</p>
              <p className="text-sm">Please check back later</p>
            </div>
          </div>
        )}
        
        {/* Loading indicator */}
        {!isLoaded && !hasError && (
          <div className="absolute top-0 left-0 w-full h-full bg-gray-100 rounded-2xl flex items-center justify-center" style={{ height: '56.25vw', maxHeight: '400px', minHeight: '200px' }}>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        )}
      </div>
    </div>
  );
} 